import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../components/layout';
import * as blogStyle from "../components/blog.module.css"

const BlogTemplate = ({ data, pageContext }) => {

  return (
    <Layout>
      <section className={blogStyle.blogSection}>
        <div className={blogStyle.headerImage}>
          <h1>Blog</h1>
        </div>

        <div className={blogStyle.mainWrapper}>

          <div className={blogStyle.article1}>
            <Link to="/blog/deploiement-de-la-5g-en-france">
              <div className={blogStyle.articleImage}>
                <StaticImage src="../images/blog_11.png" alt="image d'illustration" />
              </div>
            </Link>
            <div className={blogStyle.articleText}>
              <div className={blogStyle.articleInfos}>
                <span className={blogStyle.articleDate}>13 AOÛT 2019</span>
                <span className={blogStyle.articleCategory}>ACTUALITÉS</span>
                <span className={blogStyle.articleReadTime}>3 MIN</span>
              </div>
              <Link to="/blog/deploiement-de-la-5g-en-france">
                <h2>Déploiement de la 5G en France</h2>
              </Link>
              <p>
                Actuellement en expérimentation en France,
                la 5G (destinée à remplacer la 4G et 3G) devrait être déployée pour tous les utilisateurs d’ici 2020 sur le territoire français.
                Débits en 5G A l’heure actuelle, il est difficile d’établir la vitesse maximale de la 5G. Son déploiement a été effectué récemment sur la principauté de Monaco, ce […]
              </p>
            </div>
            <div className={blogStyle.articleAuthor}>
              <StaticImage src="../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's" />
              <span>par <em>Mobile lab's</em></span>
            </div>
          </div>

          <div className={blogStyle.article2}>
            <Link to="/blog/comment-debloquer-son-telephone-google-icloud">
              <div className={blogStyle.articleImage}>
                <StaticImage src="../images/blog_12.png" alt="image d'illustration" />
              </div>
            </Link>
            <div className={blogStyle.articleText}>
              <div className={blogStyle.articleInfos}>
                <span className={blogStyle.articleDate}>23 JUILLET 2019</span>
                <span className={blogStyle.articleCategory}>TUTORIELS</span>
                <span className={blogStyle.articleReadTime}>3 MIN</span>
              </div>
              <Link to="/blog/comment-debloquer-son-telephone-google-icloud">
                <h2>Comment débloquer un compte de son téléphone ?</h2>
              </Link>
              <p>
                Les smartphones sont souvent utilisés avec un compte Google, iCloud, Samsung ou Huawei.
                Ces comptes vous permettent d’accéder au téléchargement des applications via le Play Store ou l’App Store.
                Ils servent également d’antivols, car sans le compte et son mot de passe,
                le mobile ne peut pas être activé après réinitialisation. Ainsi, pour revendre votre […]
              </p>
            </div>
            <div className={blogStyle.articleAuthor}>
              <StaticImage src="../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's" />
              <span>par <em>Mobile lab's</em></span>
            </div>
          </div>

          <div className={blogStyle.article3}>
            <Link to="/blog/telephone-tombe-dans-leau">
              <div className={blogStyle.articleImage}>
                <StaticImage src="../images/blog_13.jpg" alt="image d'illustration" />
              </div>
            </Link>
            <div className={blogStyle.articleText}>
              <div className={blogStyle.articleInfos}>
                <span className={blogStyle.articleDate}>16 JUILLET 2019</span>
                <span className={blogStyle.articleCategory}>TUTORIELS</span>
                <span className={blogStyle.articleReadTime}>4 MIN</span>
              </div>
              <Link to="/blog/telephone-tombe-dans-leau">
                <h2>Téléphone tombé dans l’eau : les bons gestes</h2>
              </Link>
              <p>
                Dans la mer, la piscine ou dans les toilettes, ce ne sont pas les lieux préférés de votre smartphone.
                Si votre téléphone est tombé dans l’eau, il existe plusieurs gestes vitaux à effectuer pour optimiser ses chances de survie.
                Oxydation ? L’oxydation est une réaction chimique qui intervient lorsque des matériaux entrent en contact avec […]
              </p>
            </div>
            <div className={blogStyle.articleAuthor}>
              <StaticImage src="../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's" />
              <span>par <em>Mobile lab's</em></span>
            </div>
          </div>

          <div className={blogStyle.article4}>
            <Link to="/blog/huawei-un-retour-vers-android">
              <div className={blogStyle.articleImage}>
                <StaticImage src="../images/blog_14.png" alt="image d'illustration" />
              </div>
            </Link>
            <div className={blogStyle.articleText}>
              <div className={blogStyle.articleInfos}>
                <span className={blogStyle.articleDate}>10 JUILLET 2019</span>
                <span className={blogStyle.articleCategory}>ACTUALITÉS</span>
                <span className={blogStyle.articleReadTime}>2 MIN</span>
              </div>
              <Link to="/blog/huawei-un-retour-vers-android">
                <h2>Huawei, un retour vers Android ?</h2>
              </Link>
              <p>
                C’est une longue attente pour les utilisateurs des produits Huawei Android.
                Le gouvernement américain annonce une trêve commerciale avec la Chine permettant aux entreprises américaines de continuer à travailler avec Huawei.
                Le président américain annonce lors du G20 une trêve commerciale avec le fabricant chinois Huawei, ce qui leur permet de continuer à travailler avec […]
              </p>
            </div>
            <div className={blogStyle.articleAuthor}>
              <StaticImage src="../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's" />
              <span>par <em>Mobile lab's</em></span>
            </div>
          </div >

          <div className={blogStyle.article5}>
            <Link to="/blog/film-protection-resine-vs-verre-trempe">
              <div className={blogStyle.articleImage}>
                <StaticImage src="../images/blog_15.png" alt="image d'illustration" />
              </div>
            </Link>
            <div className={blogStyle.articleText}>
              <div className={blogStyle.articleInfos}>
                <span className={blogStyle.articleDate}>2 JUILLET 2019</span>
                <span className={blogStyle.articleCategory}> ACCESSOIRES</span>
                <span className={blogStyle.articleReadTime}>4 MIN</span>
              </div>
              <Link to="/blog/film-protection-resine-vs-verre-trempe">
                <h2>Film protection résine vs verre trempé</h2>
              </Link>
              <p>
                Vous êtes à la recherche de la protection parfaite pour votre écran ?
                Différence entre le film de protection résine anti-choc et verre trempé,
                on répond à toutes vos questions 🙂 Film de protection Le film de protection en résine
                est aujourd’hui utilisé dans beaucoup de domaines, par exemple, l’agence de la NASA fut l’une […]
              </p>
            </div>
            <div className={blogStyle.articleAuthor}>
              <StaticImage src="../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's" />
              <span>par <em>Mobile lab's</em></span>
            </div>
          </div >

          <div className={blogStyle.article6}>
            <Link to="/blog/telephone-lent-voici-nos-solutions">
              <div className={blogStyle.articleImage}>
                <StaticImage src="../images/blog_16.jpg" alt="image d'illustration" />
              </div>
            </Link>
            <div className={blogStyle.articleText}>
              <div className={blogStyle.articleInfos}>
                <span className={blogStyle.articleDate}>25 JUIN 2019</span>
                <span className={blogStyle.articleCategory}>TUTORIELS</span>
                <span className={blogStyle.articleReadTime}>4 MIN</span>
              </div>
              <Link to="/blog/telephone-lent-voici-nos-solutions">
                <h2>Téléphone lent ? Voici nos solutions</h2>
              </Link>
              <p>
                Votre téléphone est de plus en plus lent ? Cela ne signifie pas la fin pour lui.
                Nous avons préparé pour vous plusieurs étapes à effectuer afin de donner une seconde chance à votre mobile.
                Faire le tri Vérifiez que votre stockage n’est pas saturé. Mettez de côté vos anciennes photos et vidéos. Supprimez les […]
              </p>
            </div>
            <div className={blogStyle.articleAuthor}>
              <StaticImage src="../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's" />
              <span>par <em>Mobile lab's</em></span>
            </div>
          </div >

          <div className={blogStyle.article7}>
            <Link to="/blog/resoudre-probleme-reseau-iphone">
              <div className={blogStyle.articleImage}>
                <StaticImage src="../images/blog_17.jpg" alt="image d'illustration" />
              </div>
            </Link>
            <div className={blogStyle.articleText}>
              <div className={blogStyle.articleInfos}>
                <span className={blogStyle.articleDate}>17 JUIN 2019</span>
                <span className={blogStyle.articleCategory}>TUTORIELS </span>
                <span className={blogStyle.articleReadTime}>4 MIN</span>
              </div>
              <Link to="/blog/resoudre-probleme-reseau-iphone">
                <h2>Résoudre les problèmes de réseau iPhone</h2>
              </Link>
              <p>
                Bloqué sur « Aucun Service » ou « Recherche en cours » ?
                Votre iPhone fait face à un problème de réseau. Voici quelques étapes à suivre pour résoudre votre problème.
                Résoudre les problèmes logiciels Dans un premier temps,
                le système de votre téléphone sera le premier mis en cause (sauf si vous l’avez trempé dans l’eau 😀). Suite […]
              </p>
            </div>
            <div className={blogStyle.articleAuthor}>
              <StaticImage src="../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's" />
              <span>par <em>Mobile lab's</em></span>
            </div>
          </div >

        </div >

        <div className={blogStyle.pageButtonContainer}>
          <Link className={blogStyle.nextPageButton} to='/blog'>Articles plus récents</Link>
        </div>
      </section >

    </Layout>
  );
};

export default BlogTemplate;